import {
  Card,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Tooltip,
} from "antd";
import { ExclamationCircleOutlined } from '@ant-design/icons'; 
import { useEffect, useState } from "react";
import moment from "moment";

import lookupApi from "../../services/citizenScienceLookupService";

import {
  citizenScienceStatusEnum,
  csParticipRoleEnum,
  openNotification,
  util,
  Messages,
  Notify,
} from "@seims/shared";

import { recordError } from "src/utils/logService";

export default function ParticipantsRoles({
  onSetNextStatus,
  formRef,
  formData,
  onFormValuesChange,
  participants,
  setParticipants,
}) {
  const [checkedObjectiveList, setCheckedObjectiveList] = useState([]);
  const [checkedRoleList, setCheckedRoleList] = useState([]);
  const [selectedScienceShop, setSelectedScienceShop] = useState("");

  const [checkedConceptualList, setCheckedConceptualList] = useState([]);
  const [checkedDuringRoleList, setCheckedDuringRoleList] = useState([]);
  const [checkedAfterRoleList, setCheckedAfterRoleList] = useState([]);
  const [showOtherRole, setShowOtherRole] = useState(false);
  const [showOtherDuringProject, setShowOtherDuringProject] = useState(false);
  const [showOtherAfterProject, setShowOtherAfterProject] = useState(false);
  const [conceptualisationRolePost, setConceptualisationRolePost] = useState(
    []
  );
  const [participantRolePost, setParticipantRolePost] = useState([]);
  const [participantRoleDuring, setParticipantRoleDuring] = useState([]);
  const [contributionRecognition, setContributionRecognition] = useState([]);

  const [current, setCurrent] = useState([]);
  const dateFormat = "YYYY-MM-DD";
  const { TextArea } = Input;

  const formItemLayout = {
    layout: "vertical",
  };
  useEffect(() => {
    getConceptualizationStageRoles();
    getParticipantRolesDuring();
    getParticipantRolesPost();
    getContributionRecognition();
  }, [checkedObjectiveList, onFormValuesChange]);

  useEffect(() => {
    prePopulate();
  }, [onSetNextStatus]);

  const prePopulate = () => {
    if (!util.isEmpty(participants)) {
      form.setFieldsValue({
        conceptualisation: participants.conceptualisation,
      });
      form.setFieldsValue({ duringProject: participants.duringProject });
      form.setFieldsValue({ postProject: participants.postProject });
      form.setFieldsValue({ roles: participants.roles });
      if (participants.otherRoleDuringProject) {
        form.setFieldsValue({
          otherRoleDuringProject: participants.otherRoleDuringProject,
        });
        setShowOtherDuringProject(true);
      }
      if (participants.otherRoleAfterProject) {
        form.setFieldsValue({
          otherRoleAfterProject: participants.otherRoleAfterProject,
        });
        setShowOtherAfterProject(true);
      }
      if (participants.otherRecognition) {
        form.setFieldsValue({
          otherRecognition: participants.otherRecognition,
        });
        setShowOtherRole(true);
      }
    }
  };

  const { Option } = Select;
  const [form] = Form.useForm();
  const formName = "ParticipantsRoles";

  const atLeastOneSelected = ({ getFieldValue }) => ({
    validator(_, value) {
      const duringProject = getFieldValue("duringProject");
      const postProject = getFieldValue("postProject");
      const conceptualizationProject = getFieldValue("conceptualisation");
      if (
        (duringProject && duringProject.length > 0) ||
        (postProject && postProject.length > 0) ||
        (conceptualizationProject && conceptualizationProject.length > 0)
      ) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error(
          "Please select at least one option from either Conceptualisation, During or Post Project"
        )
      );
    },
  });

  const getConceptualizationStageRoles = async () => {
    try {
      const response = await lookupApi.getParticipantRoles(
        csParticipRoleEnum.CONCEPTUALISATION
      );
      if (response) {
        const { data } = response;
        const transformData = data.map((c) => ({
          label: c.value,
          value: c.key,
          key: c.key,
        }));
        setConceptualisationRolePost(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };
  const getParticipantRolesDuring = async () => {
    try {
      const response = await lookupApi.getParticipantRoles(
        csParticipRoleEnum.DURING
      );
      if (response) {
        const { data } = response;
        const transformData = data.map((c) => ({
          label: c.value,
          value: c.key,
          key: c.key,
        }));
        setParticipantRoleDuring(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getParticipantRolesPost = async () => {
    try {
      const response = await lookupApi.getParticipantRoles(
        csParticipRoleEnum.POST
      );
      if (response) {
        const { data } = response;
        const transformData = data.map((c) => ({
          label: c.value,
          value: c.key,
          key: c.key,
        }));

        setParticipantRolePost(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getContributionRecognition = async () => {
    try {
      const response = await lookupApi.getContributionRecognitions();
      if (response) {
        const { data } = response;
        const transformData = data.map((c) => ({
          label: c.value,
          value: c.key,
          key: c.key,
        }));

        setContributionRecognition(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onChangeRoles = (keys) => {
    setCheckedRoleList(keys);
    const selectedOptions = contributionRecognition?.filter((c) =>
      keys.includes(c.key)
    );
    const otherSelected = selectedOptions.some((c) => c.label === "Other");

    if (otherSelected) {
      setShowOtherRole(true);
    } else {
      setShowOtherRole(false);
    }
  };

  const onChangeOtherRole = (e) => {
    const { value: text } = e.target;
    const id = checkedRoleList.indexOf("Other");
    if (id !== -1) checkedRoleList[id] = text;
  };

  const onChangeOtherDuring = (e) => {
    const { value: text } = e.target;
    const id = checkedDuringRoleList.indexOf("Other specify");
    if (id !== -1) checkedDuringRoleList[id] = text;
  };

  const onChangeOtherAfter = (e) => {
    const { value: text } = e.target;
    const id = checkedAfterRoleList.indexOf("Other specify");
    if (id !== -1) checkedAfterRoleList[id] = text;
  };

  const onChangeConceptualisation = (keys) => {
    setCheckedConceptualList(keys);
  };

  const onChangeDuring = (keys) => {
    setCheckedDuringRoleList(keys);
  };

  const onChangePost = (keys) => {
    setCheckedAfterRoleList(keys);
  };

  const onSubmit = (values) => {
    onNext(values);
    const start = moment(values.startDate).format("YYYY,MM,DD");
    const end = moment(values.endDate).format("YYYY,MM,DD");
    const projectObj = {
      "Project Title": values.projectTitle,
      "Science Field": values.scienceFields,
      "Science Domain": values.scienceDomain,
      "Start Date": start,
      "End Date": end,
      "Project Location": values.location,
      Description: values.description,
      citizenScience: values.citizenScience,
      Objectives: checkedObjectiveList,
      "project Roles": checkedRoleList,
      "Science shop": selectedScienceShop,
    };
    onSetNextStatus(citizenScienceStatusEnum.ORGANIZATIONS);
  };
  const onNext = async () => {
    try {
      await form.validateFields(["projectTitle", "location"]);
      setCurrent((prev) => prev + 1);
    } catch (error) {}
  };
  const onFinishFailed = (value) => {
  };

  const onChangeScienceFields = (value) => {
  };

  const checkDate = () => {
    if (
      form.getFieldsValue().startDate !== undefined &&
      form.getFieldsValue().endDate
    ) {
      const startDate = new Date(
        moment(form.getFieldsValue().startDate).format(dateFormat)
      );
      const endDate = new Date(
        moment(form.getFieldsValue().endDate).format(dateFormat)
      );
      if (startDate > endDate) {
        var msg = util.parseMessage(
          Messages.DATE_ERROR,
          "Start date must not be later than end date"
        );
        openNotification("Project date", msg, Notify.ERROR);
      }
    }
  };

  const onValuesChange = (value) => {
    const selected = { ...value };
    const values = form.getFieldsValue(); //("otherRoleDuringProject");

    setParticipants({ ...participants, values });
    // setParticipants(selected);
  };

  return (
    <>
      <Card
        className="project-card"
        title={
          <span
            style={{ color: "black", fontWeight: "bold", fontSize: "20px" }}
          >
            <b>STEP 4: Citizen Scientist Roles</b>
          </span>
        }
        bordered={false}
        headStyle={{ border: 0, textAlign: "left" }}
      >
        <Form
          {...formItemLayout}
          name={formName}
          form={form}
          onFinish={onSubmit}
          scrollToFirstError
          initialValues={formData}
          onFinishFailed={onFinishFailed}
          ref={formRef}
          onValuesChange={onValuesChange}
        >
          <Row>
            <Col>
              <div>
                <span
                  style={{
                    display: "inline-block",
                    marginRight: "4px",
                    color: "#ff4d4f",
                    fontSize: "14px",
                    fontFamily: "SimSun, sans-serif",
                    lineHeight: 1,
                  }}
                >
                  *
                </span>
                <b>
                  Specify at least one role the citizen scientist will play in the project
                </b>
              </div>
              <br />
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Item
                name="conceptualisation"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Conceptualisation Stage
                    <Tooltip
                      title="In which of the following activities will citizen scientists will be involved during the initial planning of the project?"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                dependencies={["postProject", "duringProject"]}
                rules={[atLeastOneSelected(form)]}
              >
                <Checkbox.Group
                  onChange={onChangeConceptualisation}
                  options={conceptualisationRolePost}
                  style={{ display: "flex", flexDirection: "column" }}
                />
                {/* <Checkbox.Group onChange={onChangeDuring}>
                  {participantRoleDuring.map((data) => (
                    <Row><Checkbox key={data.value} value={data.key}>{data.value}</Checkbox></Row>
                  ))}
                </Checkbox.Group> */}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Item
                name="duringProject"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    During project
                    <Tooltip
                      title="Indicate the tasks citizen scientists will undertake while the research is ongoing"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                dependencies={["postProject", "conceptualisation"]}
                rules={[atLeastOneSelected(form)]}
              >
                <Checkbox.Group
                  onChange={onChangeDuring}
                  options={participantRoleDuring}
                  style={{ display: "flex", flexDirection: "column" }}
                />
                {/* <Checkbox.Group onChange={onChangeDuring}>
                  {participantRoleDuring.map((data) => (
                    <Row><Checkbox key={data.value} value={data.key}>{data.value}</Checkbox></Row>
                  ))}
                </Checkbox.Group> */}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Item
                name="postProject"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Post project
                    <Tooltip
                      title="Define how citizen scientists will be involved after the research is completed."
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                dependencies={["duringProject", "conceptualisation"]}
                rules={[atLeastOneSelected(form)]}
              >
                <Checkbox.Group
                  onChange={onChangePost}
                  options={participantRolePost}
                  style={{ display: "flex", flexDirection: "column" }}
                />

                {/* <Checkbox.Group onChange={onChangePost}>
                  {participantRolePost.map((data) => (
                    <Row><Checkbox key={data.value} value={data.key}>{data.label}</Checkbox></Row>
                  ))}
                </Checkbox.Group> */}
              </Form.Item>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col>
              <Form.Item
                name="roles"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <b>Specify the manner in which you recognise the contribution of the citizen scientists</b>
                    <Tooltip
                      title="Choose how the contributions of citizen scientists will be acknowledged in the project"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message:
                      "Please select at least one of the options before continuing",
                  },
                ]}
              >
                <Checkbox.Group
                  onChange={onChangeRoles}
                  options={contributionRecognition}
                  style={{ display: "flex", flexDirection: "column" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
}
